import { debug, pApiBase, pApiKey } from '../../../../../config';
import {getMonth, getWeekDay} from '../../../utils/date';

import {library, icon} from '@fortawesome/fontawesome-svg-core';
import {faFacebook, faTwitter} from '@fortawesome/free-brands-svg-icons';
import {faEnvelope, faSms} from "@fortawesome/free-solid-svg-icons";
import { getShareUrl } from '../../../../../utils/url';
import $ from 'jquery';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

// import 'intl-tel-input/build/css/intlTelInput.css';
// import intlTelInput from 'intl-tel-input';

import {parsePhoneNumber, isPossiblePhoneNumber, AsYouType} from 'libphonenumber-js/min'
import http from '../../../../../carousel-react/src/services/http';
import { string } from 'prop-types';
import {Alert} from 'bootstrap';


library.add(faFacebook, faTwitter, faEnvelope, faSms);
const facebookIcon = icon({ prefix: 'fab', iconName: 'facebook' }).html;
const twitterIcon = icon({ prefix: 'fab', iconName: 'twitter' }).html;
const envelopeIcon = icon({ prefix: 'fas', iconName: 'envelope' }).html;
const smsIcon = icon({ prefix: 'fas', iconName: 'sms' }).html;


function getImg(popUp, img) {
  const validImg = popUp.defaultImg != '' && popUp.defaultImg != 'None';
  return validImg ? popUp.defaultImg : img;
}
function hasTicketLink(ticketLink) {
  const validTicketLink = ticketLink != 'None' && ticketLink != '';
  return validTicketLink ? true : false;
}
function getTicketLinkHtml(ticketLink) {
  const ticketLinkHtml = `<a href="${ticketLink}" class="hearby-ticketlink">Buy tickets</a>`;
  return hasTicketLink(ticketLink) ? ticketLinkHtml : '';
}

function getEventDateTime(event) {
  debug && console.log(event.dayOfWeek);
  const weekDay = getWeekDay(event.dayOfWeek);
  debug && console.log('month ', getMonth(event.month));
  const month = getMonth(event.month);
  const time = event.time;
  const day = event.day;
  return `${weekDay}, ${month} ${day}, ${time}`;
}

function socialSharing(clipboardUrlToPass,twitterText,twitterVia,twitterHashTags,
                       clipboardUrlToPassForCopyLink,eventId) {
    const myButton = document.getElementById("hearbyShareButton");
    debug && console.log('hearbyShareButton', myButton);


    // let x = document.getElementById("hearby-share-sms");
    // if (x.style.display === "none") {
    //   x.style.display = "block";
    // } else {
    //   x.style.display = "none";
    // }           

    const randomInteger = Math.floor(Math.random() * 100);
    const uniqueNumberLetterCombination = eventId + String(randomInteger);

    const tippyInstance = tippy(myButton, {
      content: `<div>
                  <div id ='hearby-share-sms' style="visibility: hidden">
                   <select name="countries" id="hearby-sms-countries">
                    <option selected value="USA">USA</option>
                    <option value="GBR">GBR</option>
                   </select>
                   <input id = 'hearby-share-input-box' 
                          type="tel" pattern="[0-9]" 
                          placeholder="Enter phone number">
                   </input>
                   <button id = "hearby-share-sms-button-id-${uniqueNumberLetterCombination}" class="hearby-share-sms-button">
                      Send Free SMS With Event Info
                   </button>
                  </div>                  
                  <a href="https://www.facebook.com/sharer/sharer.php?u=${clipboardUrlToPass}&quote=this is a sweet quote&hashtag=%23hearby" class="hearby-icon hearby-social-icon
                    hearby-social-icon-facebook" target="_blank">
                    <span class="hearby-screen-only">Facebook</span>
                    ${facebookIcon}
                  </a>
                  <a href="https://twitter.com/intent/tweet?text=${twitterText}&url=${clipboardUrlToPass}&via=${twitterVia}&hashtags=${twitterHashTags}" class="hearby-icon hearby-social-icon
                      hearby-social-icon-twitter" target="_blank">
                    <span class="hearby-screen-only">Twitter</span>
                    ${twitterIcon}
                  </a>
                  <a id="email"class="hearby-icon hearby-social-icon hearby-social-icon-email" target="_blank">
                    <span class="hearby-screen-only">Email</span>
                    ${envelopeIcon}            
                  </a>
                  <a id="hearby-share-sms-btn" onclick="(function(){
                    let x = document.getElementById('hearby-share-sms');
                    if (x.style.visibility==='hidden') {
                      x.style.visibility = 'visible'
                    } else {
                      x.style.visibility = 'hidden';
                    }
                    return false;
                    })();return false;" 
                    class="hearby-icon hearby-social-icon hearby-social-icon-sms" target="_blank" 
                  >
                    <span class="hearby-screen-only">SMS</span>
                    ${smsIcon}            
                  </a>
                  <div className="hearby-clipboard-share" type="button" 
                       onclick="${navigator.clipboard.writeText(clipboardUrlToPassForCopyLink)}">
                    Copy link
                  </div>
                </div>                
               `,  
      allowHTML: true,
      trigger: 'click',
      arrow: false,
      placement: 'bottom',
      theme: 'light',
      interactive: true,
 
    });

    $(document).on('click', `#hearby-share-sms-button-id-${uniqueNumberLetterCombination}`, async function() { 
      let sharedEventLink = clipboardUrlToPassForCopyLink;
      const phoneNumValue = document.getElementById('hearby-share-input-box').value;
      const selectedCountryValue = document.getElementById('hearby-sms-countries').value;

      
      // console.log('outside of tipy phoneNumValue', selectedCountryValue, '   ', phoneNumValue);
      const correctPhoneNumUSA = isPossiblePhoneNumber(phoneNumValue, 'US');
      const correctPhoneNumGB = isPossiblePhoneNumber(phoneNumValue, 'GB');
      // console.log('US or GB? (correctPhoneNumUSA,correctPhoneNumGB): ', correctPhoneNumUSA, correctPhoneNumGB,'  ',sharedEventLink);

      if (correctPhoneNumUSA && selectedCountryValue==='USA') {
        const phoneNumber = parsePhoneNumber(phoneNumValue, 'US');
        // const phoneNumber = new AsYouType('US').input(phoneNumValue);

        const formattedPhoneNum = phoneNumber.formatInternational(phoneNumValue, 'US');
        if (!formattedPhoneNum.startsWith("+1900") && !formattedPhoneNum.startsWith("+1976")) {
          const query = `${pApiBase}/sms?destination_number=${formattedPhoneNum}` 
            +`&shared_event_link=${sharedEventLink}`;
          await http.post(
            pApiKey,
            query,
            true,
          );
          const phoneNumButtonVisibility = 
          document.getElementById('hearby-share-sms').style.visibility='hidden';
          debug && console.log('sms has been sent to the following US #: ', formattedPhoneNum);
        }
      } else if (correctPhoneNumGB && selectedCountryValue==='GBR') {
        const phoneNumber = parsePhoneNumber(phoneNumValue, 'GB');
        const formattedPhoneNum = phoneNumber.formatInternational(phoneNumValue, 'GB');
        const query = `${pApiBase}/sms?destination_number=${formattedPhoneNum}` 
        +`&shared_event_link=${sharedEventLink}`; 
        await http.post(
          pApiKey,
          query,
          true,
        );
        const phoneNumButtonVisibility = 
        document.getElementById('hearby-share-sms').style.visibility='hidden';
        debug && console.log('sms has been sent to the following GB #: ', formattedPhoneNum);
      } else {
          alert('Invalid phone number. Country name must be selected first and the number must be either in GB or US format.');
      }

    });
    debug && console.log('tippyInstance', tippyInstance);
    // $(document).off('click', '#hearby-share-sms-button-id')
    // $('#myModal').on('hidden.bs.modal','#myModal').off();
}

function getEventSharingOptionsHtml(popUp) {
  debug && console.log('eventLogic.js popUp: ', popUp);
  const clipboardUrlToPass = encodeURIComponent(getShareUrl(popUp.eventId, 
    popUp.lat, popUp.lng, 'event'));
  const clipboardUrlToPassForCopyLink = getShareUrl(popUp.eventId, 
    popUp.lat, popUp.lng, 'event');
  const twitterText = encodeURIComponent('Hearby text to be twitted...');
  const twitterVia = encodeURIComponent('attributeSourceInfo');
  const twitterHashTags = encodeURIComponent('hearby1 #hearby2');
  
 
  $(document).on('click', '#email', function() { 
    $("#email").attr('href',`mailto:?subject=Hearby event&body=
      This is the body of the email with dynamic url: ${clipboardUrlToPass}`);
  });

  $(document).one('mouseover', '#hearbyShareButton', function() { 
    socialSharing(clipboardUrlToPass,twitterText,twitterVia,twitterHashTags,
                  clipboardUrlToPassForCopyLink,popUp.eventId)
  });

  return `<div 
            className="hearby-share-popover-button" id="hearbyShareButton" class='hearby-share-popover-button'
            type="button">Share event
          </div> `;
}

export {getImg, getEventDateTime, getTicketLinkHtml, getEventSharingOptionsHtml};
